//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { convertTime } from '../../components/helpers.js'
import RequestAddRoadsLabels from './RequestAddRoadsLabels.vue'
import RequestRoads from '../RequestRoads/RequestRoads.vue'

export default {
  components: {
    RequestAddRoadsLabels: RequestAddRoadsLabels
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      requestAddRoadsLabelsDialogOpened: false,
      columns: [
        {
          name: 'time',
          label: 'Дата/время изменения',
          align: 'left',
          field: 'time',
          format: this.formatDataFromUnixTime,
          classes: 'class-bordered'
        },
        {
          name: 'comment',
          label: 'Комментарий',
          align: 'left',
          field: 'comment',
          classes: 'class-bordered'
        },
        {
          name: 'origin',
          label: 'Источник',
          align: 'left',
          field: 'origin',
          format: this.formatBbStatesHistoryOrigin,
          classes: 'class-bordered'
        },
        {
          name: 'user',
          label: 'Пользователь',
          align: 'left',
          field: 'user',
          classes: 'class-bordered'
        }
      ],
      pagination: {
        rowsPerPage: 0
      }
    }
  },
  computed: {
    displayOpenRequestRoads: function () {
      return !!this.request.exportImportStatus && this.request.name.exportImportStatus !== 'notPerformed' && !!this.request.requestRoads && (this.requestRoles.roleDispatcherOrHigher || this.requestRoles.roleContractorDispatcher)
    }
  },
  methods: {
    convertTime: convertTime,
    openRequestRoads: function () {
      this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerHidden: true,
        contentComponent: RequestRoads,
        contentProps: {
          request: this.request
        }
      })
    },
    onConfirmAddRoadsLabels: function (roadsLabels) {
      this.$set(this.request, 'roadsLabels', roadsLabels)
      this.requestAddRoadsLabelsDialogOpened = false
    },
    formatDataFromUnixTime: function (unixTime) {
      if (unixTime != null) {
        return convertTime(unixTime)
      } else {
        return 'Нет данных'
      }
    },
    formatBbStatesHistoryOrigin: function (origin) {
      if (origin == 'D2') {
        return 'Дельта 2.0'
      }
      if (origin == 'D1') {
        return 'Дельта'
      }
      if (origin == 'RS') {
        return 'Roads'
      }
    },
    formatUser: function (value) {
      if (value.fio) {
        return value.fio
      } else {
        if (value.user == 'root') {
          return 'Дельта 2.0'
        } else {
          return value.user
        }
      }
    },
    onOpenInRoadsMsk: function (url) {
      window.open(url, '_blank')
    }
  }
}

